var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Product (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-n5",
                      attrs: { cols: "12", md: "12", sm: "12" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: {
                          disabled: !(_vm.rules.id === 0 || _vm.rules.id === 3),
                          label: "ID:",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name:" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Segment" },
                        model: {
                          value: _vm.model.segment,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "segment",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.segment",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "sm",
                        attrs: { label: "Segment Start", "hide-details": "" },
                        model: {
                          value: _vm.model.segmentStart,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "segmentStart", $$v)
                          },
                          expression: "model.segmentStart",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "sm",
                        attrs: { label: "Consumable", "hide-details": "" },
                        model: {
                          value: _vm.model.consumable,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "consumable", $$v)
                          },
                          expression: "model.consumable",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "sm",
                        attrs: { label: "Stash supported", "hide-details": "" },
                        model: {
                          value: _vm.model.stashSupport,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "stashSupport", $$v)
                          },
                          expression: "model.stashSupport",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("r-tile", {
                        attrs: {
                          label: "Place",
                          model: _vm.model.place,
                          "label-tile-x": "Row:",
                          "label-tile-y": "Column:",
                          "hide-details": "",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "place", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Marker", "hide-details": "" },
                        model: {
                          value: _vm.model.marker,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "marker", _vm._n($$v))
                          },
                          expression: "model.marker",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Percent", "hide-details": "" },
                        model: {
                          value: _vm.model.percent,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "percent", _vm._n($$v))
                          },
                          expression: "model.percent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Priority", "hide-details": "" },
                        model: {
                          value: _vm.model.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "priority", _vm._n($$v))
                          },
                          expression: "model.priority",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Sticker", "hide-details": "" },
                        model: {
                          value: _vm.model.sticker,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "sticker", _vm._n($$v))
                          },
                          expression: "model.sticker",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Display:", "hide-details": "" },
                        model: {
                          value: _vm.model.display,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "display", _vm._n($$v))
                          },
                          expression: "model.display",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Quantity:", "hide-details": "" },
                        model: {
                          value: _vm.model.quantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "quantity", _vm._n($$v))
                          },
                          expression: "model.quantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Discount:", "hide-details": "" },
                        model: {
                          value: _vm.model.discount,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "discount", _vm._n($$v))
                          },
                          expression: "model.discount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Freeuse:", "hide-details": "" },
                        model: {
                          value: _vm.model.freeuse,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "freeuse", _vm._n($$v))
                          },
                          expression: "model.freeuse",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Free time:", "hide-details": "" },
                        model: {
                          value: _vm.model.freetime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "freetime", _vm._n($$v))
                          },
                          expression: "model.freetime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Reset time:", "hide-details": "" },
                        model: {
                          value: _vm.model.resettime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "resettime", _vm._n($$v))
                          },
                          expression: "model.resettime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-guard-panel", {
                        attrs: { model: _vm.model.guard },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", {
                            attrs: { den: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ open }) {
                                  return [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                          },
                                          [_vm._v("Payment")]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-fade-transition", [
                                          open
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-flex",
                                                  },
                                                },
                                                [
                                                  _c("v-divider", {
                                                    staticClass: "mx-1",
                                                    attrs: { vertical: "" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("v-divider"),
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "", "hide-details": "" },
                                  model: {
                                    value: _vm.model.payment,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "payment", $$v)
                                    },
                                    expression: "model.payment",
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "LOCAL", value: 0 },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "STORE", value: 1 },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "AD", value: 3 },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "SURVEY", value: 2 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.model.payment === 0
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c("r-currency-table", {
                                        attrs: {
                                          items: _vm.model.price,
                                          title: "Price",
                                        },
                                        on: {
                                          "update:items": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "price",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.model.payment === 1
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c("r-store-bundle-table", {
                                        attrs: {
                                          items: _vm.model.bundles,
                                          title: "Store Bundles",
                                        },
                                        on: {
                                          "update:items": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "bundles",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.model.payment === 2
                                ? _c(
                                    "v-row",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mb-4",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Survey",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.model.survey,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "survey",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "model.survey",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.model.payment === 3
                                ? _c(
                                    "v-row",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("r-ad-placement-dropdown", {
                                            attrs: {
                                              model: _vm.model.adPlacement,
                                              title: "Ad Placement",
                                              "hide-details": "",
                                            },
                                            on: {
                                              "update:model": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.model,
                                                  "adPlacement",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          model: _vm.model.rewardBunch,
                          title: "Rewards",
                          label: "Range:",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "rewardBunch", $event)
                          },
                        },
                      }),
                      _c("r-stash-bonus-bunch-panel", {
                        attrs: {
                          model: _vm.model.stashBonusBunch,
                          title: "Rewards Stash",
                          label: "Range:",
                          points: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "stashBonusBunch",
                              $event
                            )
                          },
                        },
                      }),
                      _vm.model.resettime > 0
                        ? _c("r-currency-panel", {
                            attrs: {
                              items: _vm.model.resetPrice,
                              title: "Reset Price",
                            },
                            on: {
                              "update:items": function ($event) {
                                return _vm.$set(_vm.model, "resetPrice", $event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }